<template>
    <a-modal :visible="true" :footer="null" @cancel="handleCancel"
        :class="{ [design]: true, [className]: !!className, xlarge: xlarge, large: large, fullwidth: fullwidth, 'auto-width': autoWidth }">
        <div class="custom-modal-content">
            <div class="custom-modal-header" v-if="showTitle">
                <slot name="title">
                    {{ title }}
                </slot>
                <div class="subtitle">{{ description }}</div>
            </div>
            <div class="custom-modal-body">
                <slot />
            </div>
            <div class="custom-modal-footer" v-if="showFooter">
                <div class="actions">
                    <a-button @click.stop="handleCancel"> {{ cancelText }}</a-button>
                    <a-button class="pr-confirm-btn" @click="handleConfirm" type="primary">
                        {{ okText }}
                    </a-button>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
export default {
    name: "Modal2",
    props: {
        title: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        showFooter: {
            type: Boolean,
            default: true,
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        cancelText: {
            type: String,
            default: "Cancel",
        },
        okText: {
            type: String,
            default: "Confirm",
        },
        className: {
            type: String,
            default: "",
        },
        xlarge: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
        fullwidth: {
            type: Boolean,
            default: false,
        },
        autoWidth: {
            type: Boolean,
            default: false,
        },
        top: {
            type: Number,
            default: 100,
        },
        design: {
            type: String,
            default: "v2",
        },
    },
    methods: {
        handleCancel(source) {
            this.$emit("cancel", "modal");
        },
        handleConfirm() {
            this.$emit("ok");
        },
    },
};
</script>

<style lang="scss">
.ant-modal-root.v2 {
    &.xlarge {
        .ant-modal {
            width: 80vw !important;
        }
    }

    &.large {
        .ant-modal {
            width: 60vw !important;
        }
    }

    &.fullwidth {
        .ant-modal {
            width: 95vw !important;
        }
    }

    .ant-modal-close-x {
        position: absolute;
        color: white;
        font-size: 20px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 4px;

        &:hover {
            background: var(--color-bg-ghost-hover);
        }
    }

    .ant-modal-body {
        padding: 0 !important;
        font-size: 14px;
        font-weight: 400;
        color: var(--color-text-default);
        line-height: 24px;
    }

    .ant-modal-content {
        border-radius: 4px;
    }

    .custom-modal-content {
        display: flex;
        flex-direction: column;

        .custom-modal-header {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 20px;
            border-bottom: 1px solid var(--color-border-default);

            font-weight: 700;
            color: var(--color-text-strong-default);
            font-size: 24px;
            line-height: 32px;

            .title {
                font-weight: 700;
                color: var(--color-text-strong-default);
                font-size: 24px;
                line-height: 32px;
            }
        }

        .custom-modal-body {
            display: flex;
            flex-direction: column;
            gap: 10px;
            padding: 20px 40px;
            background: var(--color-bg-neutral-default);
        }

        .custom-modal-footer {
            border-top: 1px solid var(--color-border-default);
            padding: 20px;

            .actions {
                display: flex;
                gap: 5px;
                width: 100%;
                justify-content: flex-end;
            }
        }
    }
}

/* v3 design variant */
.ant-modal-root.v3 {
    &.xlarge {
        .ant-modal {
            width: 80vw !important;
        }
    }

    &.large {
        .ant-modal {
            width: 60vw !important;
        }
    }

    &.fullwidth {
        .ant-modal {
            width: 95vw !important;
        }
    }

    &.auto-width {
        .ant-modal {
            width: auto !important;
        }
    }

    .ant-modal-content {
        border-radius: 28px;
    }

    .ant-modal-wrap {
        backdrop-filter: blur(2px);
    }

    .custom-modal-body {
        background: transparent;
    }
}
</style>
